{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "أداة انتقاء اللون",
  "colorSwatch": "تغيير الألوان",
  "transparent": "شفاف",
  "twoDimensionalSlider": "مُنزلق 2D"
}
